import { render, staticRenderFns } from "./TalkLink.vue?vue&type=template&id=57cac4ac&scoped=true&"
import script from "./TalkLink.vue?vue&type=script&lang=js&"
export * from "./TalkLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cac4ac",
  null
  
)

export default component.exports